import {
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
} from "../actions/verify";

const initialState = {
  state: "idle" as "idle" | "loading" | "success" | "failure",
  error: null as string | null,
  statusCode: null as number | null,
};

export default function verifyEmail(state = initialState, action: any) {
  switch (action.type) {
    case VERIFY_EMAIL_REQUEST:
      return { state: "loading" as const, error: null, statusCode: null };
    case VERIFY_EMAIL_SUCCESS:
      return { state: "success" as const, error: null, statusCode: null };
    case VERIFY_EMAIL_FAILURE:
      return { state: "failure" as const, error: action.payload?.result?.message ?? null, statusCode: action.payload?.statusCode ?? null };
    default:
      return state;
  }
}
